<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-sys__userviewreport}">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <!-- <el-form-item>
          <el-input v-model="dataForm.id" placeholder="id" clearable></el-input>
        </el-form-item> -->
        <el-form-item>
          <el-select v-model="dataForm.channelId" filterable clearable placeholder="渠道名称">
            <el-option
                    v-for="item in channels"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="dateValue"
            type="daterange"
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="getTimes"
            value-format="yyyy-MM-dd"
            align="right">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('sys:userviewreport:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('sys:userviewreport:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item> -->
      </el-form>
      <div class="tip_box">
        <h3>说明</h3>
        <p>报表时效：次日6:00后可查看上一日数据;</p>
        <p>实际UV：同一天同一个IP多次点击链接记为1次;</p>
        <p>注册数：输完手机号验证码、并点击“去借款”验证通过后，记为1次。去重规则：手机号不存在记为一次，存在不计入。</p>
      </div>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <!-- <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column> -->
        <!-- <el-table-column prop="id" label="" header-align="center" align="center"></el-table-column> -->
        <el-table-column prop="currentData" label="日期" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="channelId" label="渠道id" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="chargingMode" label="渠道对接方式" header-align="center" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ getDictLabel(scope.row.chargingMode) }}
          </template>
        </el-table-column>
        <el-table-column prop="channelName" label="渠道名称" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="realUv" label="实际UV" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="uv" label="UV" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="realRegNum" label="实际注册数" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="regNum" label="注册数" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="realRate" label="实际转化率" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <!-- <el-table-column prop="rate" label="转化率" header-align="center" align="center" show-overflow-tooltip></el-table-column> -->
        <el-table-column prop="" label="实际进件联登数" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="pushSuccessNum" label="进件成功数" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="sucRate" label="进件成功率" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="createDate" label="创建时间" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <!-- <el-table-column prop="updater" label="更新者" header-align="center" align="center" show-overflow-tooltip></el-table-column> -->
        <el-table-column prop="updateDate" label="更新时间" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('sys:userviewreport:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
            <el-button v-if="$hasPermission('sys:userviewreport:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './userviewreport-add-or-update'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/sys/userviewreport/page',
        getDataListIsPage: true,
        exportURL: '/sys/userviewreport/export',
        deleteURL: '/sys/userviewreport',
        deleteIsBatch: true
      },
      dataForm: {
        id: ''
      },
      channels:[],
      modeList:[],
      dateValue: '',
      pickerOptions: {
          shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              picker.$emit('pick', [start, end]);
            }
          },
            
          {
            text: '昨天',
            onClick(picker) {
              console.log(picker)
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              end.setTime(end.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '过去七天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: "上周",
            onClick(picker) {
              // 上周开始时间
              const starta = new Date();
              var first = starta.getDate() - starta.getDay() - 6;
              var startDate = new Date(starta.setDate(first));
              const start = new Date(startDate);
              start.setHours(0, 0, 0, 0);
              //  上周结束时间
              var currentDate = new Date();
              var firsts = currentDate.getDate() - currentDate.getDay() - 6;
              var last = firsts + 6;
              var endDate = new Date(currentDate.setDate(last));
              const end = new Date(endDate);
              end.setHours(23, 59, 59, 0);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "本周",
            onClick(picker) {
              var end = new Date();
              var week = end.getDay();
              console.log(week,'week')
              //一天的毫秒数
              var millisecond = 1000 * 60 * 60 * 24;
              //减去的天数
              var minusDay = week != 0 ? week - 1 : 6;
              
              //本周 周一
              var monday = new Date(end.getTime() - minusDay * millisecond);
              const start = new Date(monday);
              start.setHours(0, 0, 0, 0);
              console.log("2312", start, end);
              picker.$emit("pick", [start, end]);
            },

          },
       ]
        },
    }
  },
  components: {
    AddOrUpdate
  },
  created() {
    this.getchannelsOptions();
    this.getModeOptions()
  },
  methods: {
    getDictLabel(value) {
      const dictItem = this.modeList.find(item => item.value == value);
      return dictItem ? dictItem.label : ''; 
    },
    //初始化下拉框中的选项
    async getModeOptions() {
      this.$http.get(`/sys/dict/data/list?dataType=charging_mode`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.citys=[];
        if (res.data!=null){
          res.data.forEach(element => {
            this.modeList.push({label:element.dictLabel,value:element.dictValue})
          })
        }
      }).catch(() => {})
    },
    getTimes() {
        if (this.dateValue != null) {
          this.dataForm.startDate = this.dateValue[0]
          this.dataForm.endDate = this.dateValue[1]
        }else{
          delete this.dataForm.startDate 
        delete this.dataForm.endDate
        }
      },
    //初始化渠道下拉框中的选项
    async getchannelsOptions() {
      this.$http.get(`/sys/channels/list`).then(({data: res}) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.channels = [];
        if (res.data != null) {
          res.data.forEach(element => {
            this.channels.push({label: element.name, value: element.id})
          })
        }
      }).catch(() => {
      })
    },
  }
}
</script>
<style scoped lang="scss">
.tip_box{
  background-color: #f2f2f2;
  padding : 16px;
  margin-bottom: 30px;
  p{
    margin-left: 30px;
    line-height: 22px;
  }
}
</style>
